export default __webpack_public_path__ + "static/media/backGround.91108a35.png";